module.exports = __webpack_public_path__ + "static/media/icona storico ordini.753c5064.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icona storico ordini.png
// module id = 98
// module chunks = 0